import { maskPhone } from '../../../../utils/phoneUtils';

// Contatos do cadastro em Pessoas sugeridos ao vincular o beneficiário (AF-3973): preenchem só os
// campos vazios, porque o contato do jurídico com o escritório pode ser outro. WhatsApp não conta
// como telefone, mesma regra do contato exibido no `person`.
export interface PersonContact {
    type: string;
    content: string;
}

export interface BeneficiaryContacts {
    email: string;
    phone: string;
    mobile: string;
}

const firstOf = (contacts: PersonContact[], type: string): string =>
    contacts.find((contact) => contact.type === type && contact.content)?.content || '';

export const prefillContacts = (
    current: BeneficiaryContacts,
    personContacts: PersonContact[] | undefined,
): BeneficiaryContacts => {
    const contacts = personContacts || [];
    return {
        email: current.email || firstOf(contacts, 'EMAIL'),
        phone: current.phone || maskPhone(firstOf(contacts, 'PHONE')),
        mobile: current.mobile || maskPhone(firstOf(contacts, 'MOBILE')),
    };
};
